@if (rows.length) {
  <dl class="general-device-info" data-testid="device-general-info-table">
    @for (item of rows; track $index) {
      <dt class="info-label" data-testid="device-general-info-label">
        {{ item.label }}
      </dt>
      <dd class="info-value" data-testid="device-general-info-value">
        {{ item.value || 'n/a' }}
      </dd>
    }
  </dl>
}
